var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sync"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.syncError)?_c('p',{staticClass:"sync-error",class:{ 'sync-info': ! _vm.online }},[_vm._v(_vm._s(_vm.syncError))]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }